// extracted by mini-css-extract-plugin
module.exports = {"eurozone__section":"EuroZoneInfo_eurozone__section__B1TjD"};